import { render } from "./PBXExtension.vue?vue&type=template&id=b1d23c0e"
import script from "./PBXExtension.vue?vue&type=script&lang=js"
export * from "./PBXExtension.vue?vue&type=script&lang=js"

import "./PBXExtension.vue?vue&type=style&index=0&id=b1d23c0e&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__